import { User, Order, Tour, OrderStatus } from '../types'

const USERS_KEY = 'vipclean_users'
const ORDERS_KEY = 'vipclean_orders'
const TOURS_KEY = 'vipclean_tours'

// Seed data
const INITIAL_USERS: User[] = [
  {
    id: 'u1',
    name: 'Admin Principal',
    email: 'admin@vipclean.tn',
    password: '123',
    role: 'ADMIN',
    active: true,
  },
  {
    id: 'u2',
    name: 'Chauffeur Ahmed',
    email: 'driver@vipclean.tn',
    password: '123',
    role: 'CHAUFFEUR',
    active: true,
  },
  {
    id: 'u3',
    name: 'Agent Dépôt',
    email: 'depot@vipclean.tn',
    password: '123',
    role: 'DEPOT',
    active: true,
  },
]

const INITIAL_ORDERS: Order[] = [
  {
    id: 'CMD-1001',
    clientId: 'CL-001',
    clientName: 'Sophie Ben Ali',
    clientPhone: '55123456',
    address: '15 Rue de la République, La Marsa',
    zone: 'La Marsa',
    type: 'TAPIS',
    quantity: 2,
    estimatedDeliveryDate: '2023-11-15',
    status: 'CREEE',
    priority: 0,
    deliveryAttempts: 0,
    timeline: [
      {
        date: new Date().toISOString(),
        userId: 'u2',
        userName: 'Chauffeur Ahmed',
        action: 'Création commande',
        status: 'CREEE',
      },
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'CMD-1002',
    clientId: 'CL-002',
    clientName: 'Karim Tounsi',
    clientPhone: '22987654',
    address: 'Av Habib Bourguiba, Tunis',
    zone: 'Tunis Centre',
    type: 'HOUSSE',
    quantity: 4,
    estimatedDeliveryDate: '2023-11-16',
    status: 'RECUE_DEPOT',
    priority: 0,
    deliveryAttempts: 0,
    timeline: [
      {
        date: new Date(Date.now() - 86400000).toISOString(),
        userId: 'u2',
        userName: 'Chauffeur Ahmed',
        action: 'Création commande',
        status: 'CREEE',
      },
      {
        date: new Date(Date.now() - 80000000).toISOString(),
        userId: 'u2',
        userName: 'Chauffeur Ahmed',
        action: 'Collecte effectuée',
        status: 'COLLECTEE',
      },
      {
        date: new Date(Date.now() - 70000000).toISOString(),
        userId: 'u3',
        userName: 'Agent Dépôt',
        action: 'Réception dépôt',
        status: 'RECUE_DEPOT',
      },
    ],
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 70000000).toISOString(),
  },
]

export const storage = {
  getUsers: (): User[] => {
    const data = localStorage.getItem(USERS_KEY)
    if (!data) {
      localStorage.setItem(USERS_KEY, JSON.stringify(INITIAL_USERS))
      return INITIAL_USERS
    }
    return JSON.parse(data)
  },

  saveUser: (user: User) => {
    const users = storage.getUsers()
    const index = users.findIndex((u) => u.id === user.id)
    if (index >= 0) {
      users[index] = user
    } else {
      users.push(user)
    }
    localStorage.setItem(USERS_KEY, JSON.stringify(users))
  },

  getOrders: (): Order[] => {
    const data = localStorage.getItem(ORDERS_KEY)
    if (!data) {
      localStorage.setItem(ORDERS_KEY, JSON.stringify(INITIAL_ORDERS))
      return INITIAL_ORDERS
    }
    return JSON.parse(data)
  },

  saveOrder: (order: Order) => {
    const orders = storage.getOrders()
    const index = orders.findIndex((o) => o.id === order.id)
    if (index >= 0) {
      orders[index] = order
    } else {
      orders.push(order)
    }
    localStorage.setItem(ORDERS_KEY, JSON.stringify(orders))
  },

  getTours: (): Tour[] => {
    const data = localStorage.getItem(TOURS_KEY)
    return data ? JSON.parse(data) : []
  },

  saveTour: (tour: Tour) => {
    const tours = storage.getTours()
    const index = tours.findIndex((t) => t.id === tour.id)
    if (index >= 0) {
      tours[index] = tour
    } else {
      tours.push(tour)
    }
    localStorage.setItem(TOURS_KEY, JSON.stringify(tours))
  },

  // Helper to clear data for testing
  clearAll: () => {
    localStorage.removeItem(USERS_KEY)
    localStorage.removeItem(ORDERS_KEY)
    localStorage.removeItem(TOURS_KEY)
  },
}
